import * as tslib_1 from "tslib";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import PropTypes from "prop-types";
import { SkipNavLink as ReachSkipNavLink, SkipNavContent as ReachSkipNavContent } from "@reach/skip-nav";
import { Text } from "./Text";
import { useTheme } from "./Theme/Providers";
export var SkipNavLink = function (_a) {
    var _b = _a.children, children = _b === void 0 ? "Skip to content" : _b, other = tslib_1.__rest(_a, ["children"]);
    var theme = useTheme();
    return (jsx(ReachSkipNavLink, tslib_1.__assign({ css: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            color: theme.colors.text.default,
            textDecoration: "none",
            width: "1px",
            ":focus": {
                background: theme.colors.background.layer,
                clip: "auto",
                height: "auto",
                left: theme.spaces.md,
                top: theme.spaces.md,
                position: "fixed",
                zIndex: 40,
                width: "auto",
                padding: theme.spaces.md,
                borderRadius: theme.radii.md
            }
        } }, other),
        jsx(Text, null, children)));
};
SkipNavLink.propTypes = {
    children: PropTypes.node
};
export var SkipNavContent = ReachSkipNavContent;
